import {
  getDefaultStatisticItem,
  getTeamLabelByNumber,
  getTeamNumberByLabel
} from '../../utils/utils'

let previousActiveSide = null
let previousPlayTime = null
let isPeriodActive = false
let lastPenaltyKicks = 0
let lastPossession = 0
let goalsInARow = {
  home: 0,
  away: 0,
  lastGoalTeam: 0
}

export default {
  statisticScheme: {
    'ACE': getDefaultStatisticItem('statistic.tennis.ace'),
    'SERVE_SCORES': getDefaultStatisticItem('statistics.scoresOnServe'),
    'RECIEVE_SCORES': getDefaultStatisticItem('statistics.scoresOnReceive'),
    'POINT_SERVE_ERROR': getDefaultStatisticItem(),
    'POINT_BLOCK': getDefaultStatisticItem(),
    'MAX_GOALS_IN_A_ROW': getDefaultStatisticItem('statistic.scoreMax', { maxValueInSumStatistic: true })
  },
  statisticEvents: {
    'ACE': 'POINT_ACE',
    'POINT_SERVE_ERROR': 'POINT_SERVE_ERROR',
    'POINT_BLOCK': 'POINT_BLOCK'
  },
  statisticOrder: [
    'SERVE_SCORES',
    'RECIEVE_SCORES',
    'MAX_GOALS_IN_A_ROW',
    'ACE',
    'POINT_SERVE_ERROR',
    'POINT_BLOCK'
  ],
  statisticFunction (event) {
    const { EventCode } = event

    if (EventCode === 'HEARTBEAT') return

    processMaxGoalsInARow.bind(this)(event)
    processServeScores.bind(this)(event)
  }
}

function processServeScores (event) {
  const { getActiveSide } = this
  const { TeamNumber, EventCode, GamePeriod } = event
  const eventTeam = getTeamLabelByNumber(TeamNumber)

  if (EventCode !== 'POINT') {
    return
  }

  if (eventTeam === getActiveSide) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SERVE_SCORES',
      period: GamePeriod,
      team: eventTeam,
      type: 'increment'
    })

    return
  }

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'RECIEVE_SCORES',
    period: GamePeriod,
    team: eventTeam,
    type: 'increment'
  })
}

function processMaxGoalsInARow (event) {
  const { getMatchPeriods } = this
  const { TeamNumber, EventCode, GamePeriod } = event

  if (!GamePeriod) return

  const teamLabel = getTeamLabelByNumber(TeamNumber)
  const currentStatisticValue =
    getMatchPeriods[GamePeriod].statistic.defaultStatistic['MAX_GOALS_IN_A_ROW'][teamLabel]

  if (EventCode !== 'POINT') return

  if (goalsInARow.lastGoalTeam === TeamNumber) {
    goalsInARow[teamLabel]++
  } else {
    goalsInARow = {
      ...{
        away: 0,
        home: 0,
        lastGoalTeam: TeamNumber
      },
      ...{
        [teamLabel]: 1
      }
    }
  }

  const newStatValue = goalsInARow[teamLabel]

  if (currentStatisticValue >= newStatValue) return

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'MAX_GOALS_IN_A_ROW',
    period: GamePeriod,
    team: teamLabel,
    value: newStatValue
  })
}